export function buildPatientListRoute({ patientId, clinicId }) {
  const params = new URLSearchParams()

  if (clinicId) {
    params.set("clinicId", String(clinicId))
  }

  const query = params.toString()
  return `/patients/${patientId}${query ? `?${query}` : ""}`
}

export function openPatientRoute({ navigate, patientId, clinicId }) {
  navigate(buildPatientListRoute({ patientId, clinicId }))
}

export function openClinicalHistoryRoute({
  navigate,
  patientId,
  clinicId,
  firstName,
  lastName,
  phone
}) {
  const params = new URLSearchParams({
    patientId: String(patientId),
    clinicId: String(clinicId),
    firstName: firstName || "",
    lastName: lastName || "",
    phone: phone || ""
  })

  navigate(`/clinical-history?${params.toString()}`)
}

export function openAgendaFromPatient({
  patientId,
  clinicId,
  source = "patients_page"
}) {
  localStorage.setItem(
    "odontoflow_new_appointment_context",
    JSON.stringify({
      patientId,
      clinicId,
      source
    })
  )
}